import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  switchControlLabel: {
    marginLeft: '0 !important',
    paddingLeft: '0 !important',
    alignItems: 'center !important',
    justifyContent: 'flex-start',
    width: 'auto',

    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
      fontStyle: 'normal',
      color: theme.palette.font.secondary,
    },
  },
  switchControlLabelFullWidth: {
    width: '100%',
    justifyContent: 'space-between',
  },
}));
